import axios from 'axios';

const api = axios.create({
    baseURL: 'https://api-panda.com/',
    headers: {
        'X-Client': 'flatuicolors',
    }
});
api.interceptors.response.use(res => res.data);

const createId = () => {
    const id = Math.random().toString(36).substr(2, 9);
    localStorage.setItem('fuic.id', id);

    return id;
};

const uniqueId = localStorage.getItem('fuic.id') || createId();

export const sendActivity = (type, value) => {
    const data = {
        type,
        value,
        uniqueId,
        data: {
            medium: 'flatuicolors'
        }
    };

    return api.post('v3/user-activity', data);
};

export const fetchPandaSponsors = async () => {
    const campaigns = await api.post('v4/campaigns', { news: 3, ...getPreviousAds() });
    setPreviousAds(campaigns.newsCampaigns);
    return campaigns;
};

export const fetchPandaShout = () => {
    return api.get('/shout');
};

function getPreviousAds() {
    const seenNews = JSON.parse(localStorage.getItem('fuic.ad.seen') || '{}');
    const newsSponsor = localStorage.getItem('fuic.ad.sponsor') || null;

    return { seenNews, newsSponsor };
}

function setPreviousAds(campaigns) {
    const seenLsKey = 'fuic.ad.seen';
    const seenNews = JSON.parse(localStorage.getItem(seenLsKey) || '{}');

    campaigns.forEach((campaign, idx) => {
        seenNews[campaign.sponsor] = campaign._id;

        if (idx === campaigns.length - 1) {
            localStorage.setItem('fuic.ad.sponsor', campaign.sponsor);
        }
    });

    localStorage.setItem(seenLsKey, JSON.stringify(seenNews));
}



// WEBPACK FOOTER //
// ./src/api.js